// extracted by mini-css-extract-plugin
export default {"clockWrapper":"Clock_clockWrapper__UyJCq","timeblock":"Clock_timeblock__-1OBY","date":"Clock_date__DevbW"};